/* lib/api/reports.js — порт боевого reports-клиента (frontend/src/lib/api/reports.js, 1:1).
 * Фильтры: type ('foodcost'|'abc'|'inventory'), subject_kind, subject_id (AND).
 * Backend scope'ит по X-Workspace-Id (apiFetch). Текстового поиска по сущности на бэке НЕТ. */

import { apiFetch, getActiveWorkspaceId } from './client.js';

export function listReports(params = {}) {
  const q = new URLSearchParams();
  if (params.type) q.set('type', params.type);
  if (params.subject_kind) q.set('subject_kind', params.subject_kind);
  if (params.subject_id != null && params.subject_id !== '') q.set('subject_id', String(params.subject_id));
  const qs = q.toString();
  return apiFetch(`/api/reports/${qs ? `?${qs}` : ''}`);
}

export const getReport = (id) => apiFetch(`/api/reports/${id}/`);
export const updateReport = (id, body) => apiFetch(`/api/reports/${id}/`, { method: 'PATCH', body });
export const deleteReport = (id) => apiFetch(`/api/reports/${id}/`, { method: 'DELETE' });

// Скачивание отчёта файлом Word — серверная сборка GET /<id>/export.docx.
// Raw fetch (не apiFetch): нужен blob, а X-Workspace-Id ставим вручную —
// тот же приём, что downloadXlsx в analytics.js (window.open заголовок
// не передаёт и уронил бы скоуп на personal-workspace). GET → CSRF не нужен.
export async function downloadReportDocx(id, filename) {
  const wsId = getActiveWorkspaceId();
  const headers = {};
  if (wsId) headers['X-Workspace-Id'] = String(wsId);
  const res = await fetch(`/api/reports/${id}/export.docx`, { credentials: 'same-origin', headers });
  if (!res.ok) throw new Error(`Report export failed: ${res.status}`);
  const blob = await res.blob();
  const link = document.createElement('a');
  const objUrl = URL.createObjectURL(blob);
  link.href = objUrl;
  link.download = filename || `report-${id}.docx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objUrl);
}

export const REPORT_TYPES = {
  foodcost: { slug: 'foodcost', label: 'Оптимизация FC', skill: 'foodcost-optimize' },
  abc: { slug: 'abc', label: 'ABC-анализ', skill: 'abc-analyze' },
  inventory: { slug: 'inventory', label: 'Инвентаризация', skill: 'inventory-analyze' },
};
